import { MouseEventHandler } from 'react';

import { Icon } from '../../components/icon';
import { Tooltip } from '../../components/tooltip';

import styles from './rollback-controls.module.scss';

interface RollbackControlsProps {
  onDragStart: (e: React.DragEvent) => void;
  onDragEnd: () => void;
  onReset?: MouseEventHandler;
}

export const RollbackControls = ({ onDragStart, onDragEnd, onReset }: RollbackControlsProps) => {
  const handleReset = () => {
    // Create a synthetic event-like object for the reset handler
    onReset?.({} as React.MouseEvent<HTMLDivElement>);
  };

  return (
    <Tooltip
      content={
        <>
          <strong>Reset rollback</strong>
          <br />
          Re-enable temporarily disabled steps
        </>
      }>
      <div
        role="button"
        tabIndex={0}
        aria-label="Rollback point. Click to reset, drag to move."
        className={styles.rollbackControls}
        draggable
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onClick={(e) => {
          e.stopPropagation();
          onReset?.(e);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            handleReset();
          }
        }}>
        <div className={styles.rollbackLabel}>ROLLBACK POINT</div>
        <div className={styles.resetButton}>
          <Icon name="X" size={12} aria-hidden />
        </div>
      </div>
    </Tooltip>
  );
};
